export default {
  "dailyDetail.monthMobilization": "当月動員",
  "dailyDetail.monthBoxOffice": "当月興行収入",
  "dailyDetail.exceptedNumber": "入場者数",
  "dailyDetail.credit": "ｸﾚｼﾞｯﾄ",
  "dailyDetail.beforehand.cash": "事前（現金）",
  "dailyDetail.beforehand.credit": "事前（ｸﾚｼﾞｯﾄ）",
  "dailyDetail.number": "枚數",
  "dailyDetail.seatNumber": "席数",
  "dailyDetail.today": "当日",
  "dailyDetail.before": "事前",
  "dailyDetail.windowCredit": "窓口（ｸﾚｼﾞｯﾄ）",
  "dailyDetail.net": "ネット",
  "dailyDetail.theaterAdvance": "劇場前売",
  "dailyDetail.commonCoupon": "共通券",
  "dailyDetail.onCoupons": "券種売上",
  "dailyDetail.seatSales": "席・バージョン追加料金",
  "dailyDetail.paymentRefund": "支払方法（先売券の払戻)",
  "dailyDetail.preSale": "先行販売",
  "dailyDetail.show": "上映",
  "dailyDetail.shop": "売店（物販）",
  "dailyDetail.shop.salesGroup": "売店売上区分",
  "dailyDetail.shop.dayNon": "当日売上(対象外)",
  "dailyDetail.shop.preSale": "事前販売",
  "dailyDetail.shop.dayZero": "当日売上(非課税)",
  "dailyDetail.shop.dayTeight": "当日売上(8%)",
  "dailyDetail.shop.dayTen": "当日売上(10%)",
  "dailyDetail.shop.dayTotal": "当日売上合計",
  "dailyDetail.shop.advanceSalesTotal": "先行販売",
  "dailyDetail.shop.monthNon": "当月売上(対象外)",
  "dailyDetail.shop.monthZero": "当月売上(非課税)",
  "dailyDetail.shop.monthTeight": "当月売上(8%)",
  "dailyDetail.shop.monthTen": "当月売上(10%)",
  "dailyDetail.shop.monthTotal": "当月売上合計",
  "dailyDetail.shop.paymentRefund": "前日までの販売分の払戻",
  "dailyDetail.otherRevenue": "その他の営業収入",
  "dailyDetail.otherRevenue.accountsRecovery": "売掛金現金回収",
  "dailyDetail.otherRevenue.otherCashRecovery": "その他営業収入現金回収",
  "dailyDetail.otherRevenue.accountsPayment": "買掛金現金支払",
  "dailyDetail.otherRevenue.otherCashPayment": "その他仕入現金支払",
  "dailyDetail.otherRevenue.salesAccounts": "売掛金-その他営業収入",
  "dailyDetail.specialSeatSalesBeforeRefund": "席・バージョン追加料金売上（払戻/取消 控除前）",
  "dailyDetail.specialSeatSalesAfterRefund": "特別席売上 （払戻/取消  控除後）",
  "dailyDetail.couponAccountReceivable": "劇場引換券（売掛金）"
};